import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useAppSelector } from '../../../../reduxService/hooks';
import { EErrorBreadcrumb, getErrorBreadcrumb } from '../../../utils/utils';
import { selectProject, selectResults } from '../../selector/conversion';
import CommonTabResults from '../CommonTabResults/CommonTabResults';
import './GraphicalResults.scss';
import { IGraphicalResultsProps } from './IGraphicalResults';
import ChannelDesign from './channelDesign/ChannelDesign';
import DischargeCurve from './dischargeCurve/DischargeCurve';
import GeneralResults from './generalResults/GeneralResults';
import Materials from './materials/Materials';

const GraphicalResults = (props: IGraphicalResultsProps) => {
    const { t, i18n } = useTranslation();
    const results = useAppSelector(selectResults);

    const error = getErrorBreadcrumb();

    return (
        <Tabs id='GraphicalResults'>
            <TabPanel>
                <CommonTabResults />
                <ChannelDesign />
            </TabPanel>
            {!results.initialState && (
                <>
                    <TabPanel>
                        <CommonTabResults />
                        <DischargeCurve />
                    </TabPanel>

                    <TabPanel className='tablet-results-panel'>
                        <CommonTabResults />
                        <Materials />
                    </TabPanel>
                    <TabPanel className='tablet-results-panel'>
                        <CommonTabResults />
                        <GeneralResults />
                    </TabPanel>
                </>
            )}
            <TabList>
                <Tab>{t('graphical_results_channel_design')}</Tab>
                {!results.initialState && (
                    <>
                        <Tab style={{ backgroundColor: '#004652', color: 'white' }}>{t('graphical_results_discharge_curve')}</Tab>
                        <Tab style={error.type & EErrorBreadcrumb.Macra1_Material ? { backgroundColor: '#b91023', color: 'white' } : { backgroundColor: '#004652', color: 'white' }}>
                            {t('graphical_results_materials')}
                        </Tab>
                        <Tab style={{ backgroundColor: '#004652', color: 'white' }}>{t('graphical_results_general_results')}</Tab>
                    </>
                )}
            </TabList>
        </Tabs>
    );
};

export default GraphicalResults;
